import { AnimationBaseController, IAnimationControllerConfiguration, Inject } from '@denishussar/html5-game-engine';
import { GameLogic } from '../../../Logic/GameLogic';
import { RopesModel } from '../../../Models/MiniGames/RopesModel';

export interface IRopesButtonControllerOptions {
    color: string;
    index: number;
    onClick: (color: string, index: number) => void;
}

export class RopesButtonController extends AnimationBaseController {
    $model: RopesModel;

    public constructor(
        @Inject private _options: IRopesButtonControllerOptions,
        @Inject private _gameLogic: GameLogic,
    ) {
        super('RopesButtonController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return {
            onPointerDown: e => {
                this._options.onClick(this._options.color, this._options.index);
            },
            onPointerOver: () => {
                this.gotoAndStop('hover');
            },
            onPointerOut: () => {
                this.gotoAndStop('normal');
            },
        };
    }

    protected onInitialize(): void {
        const hitArea = this.getDisplayObjectByQuery('hitArea')[0] as PIXI.Container;
        hitArea.visible = false;
        const multiplier = 4;
        this.display.hitArea = new PIXI.Rectangle(
            multiplier*(hitArea.x - hitArea.width / 2),
            multiplier*(hitArea.y - hitArea.height / 2),
            multiplier*hitArea.width,
            multiplier*hitArea.height,
        );
    }

    protected onResize(width: number, height: number, scale: number): void {
    }
}
